module.exports = __webpack_public_path__ + "img/serifnew_box22.05661d0e.jpg";